// sets up browser classes on body without using user agent strings were possible.

import * as browser from '../tests';

export default function applyBrowserClasses() {
	const classes = document.body.classList;

	if (browser.android) {
		classes.add('device-android');
	} else if (browser.ios) {
		classes.add('device-ios');
	}

	if (browser.chrome) {
		classes.add('browser-chrome');
	} else if (browser.firefox) {
		classes.add('browser-firefox');
	} else if (browser.edge) {
		classes.add('browser-edge');
	} else if (browser.ie) {
		classes.add('browser-ie');
	} else if (browser.safari) {
		classes.add('browser-safari');
	}
}
